import { createSlice } from "@reduxjs/toolkit";
import {
  ProfileSlice,
  StepPayload,
  UploadFilePayload,
} from "../../types/slices/ProfileSlice";

const initialState: ProfileSlice = {
  steps: [
    { id: 1, isCompleted: false },
    { id: 2, isCompleted: false },
    { id: 3, isCompleted: false },
  ],
  currentStep: 1,
  documentType: "",
  uploadFileDialog: false,
  showUpload: false,
  uploadDocument: { file: null, preview: null },
  uploadFrontDocument: { file: null, preview: null },
  uploadBackDocument: { file: null, preview: null },
  uploadProfile: { file: null, preview: null },
  issueCountry: "TH",
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    onClickStep: (state, { payload }) => {
      state.currentStep = payload;
    },
    personalDataStep: (state) => {
      state.currentStep = 2;
    },
    identityStep: (state) => {
      state.currentStep = 3;
    },
    initStep: (state, { payload }: StepPayload) => {
      const { isUpdatePersonalData, isVerifiedEmail, isVerifiedIdentity } =
        payload;
      const steps = [
        { id: 1, isCompleted: isVerifiedEmail },
        { id: 2, isCompleted: isUpdatePersonalData },
        { id: 3, isCompleted: isVerifiedIdentity },
      ];
      state.steps = steps;
    },
    toggleUploadDialog: (state) => {
      state.uploadFileDialog = !state.uploadFileDialog;
    },
    selectDocumentType: (state, { payload }) => {
      state.documentType = payload;
    },
    handleShowUpload: (state) => {
      state.showUpload = true;
    },
    setUploadDocumentFile: (state, { payload }: UploadFilePayload) => {
      const { file } = payload;
      state.uploadDocument.file = file;
    },
    setUploadDocumentPreview: (state, { payload }: UploadFilePayload) => {
      const { preview } = payload;
      state.uploadDocument.preview = preview;
    },
    setUploadFrontDocumentFile: (state, { payload }: UploadFilePayload) => {
      const { file } = payload;
      state.uploadFrontDocument.file = file;
    },
    setUploadFrontDocumentPreview: (state, { payload }: UploadFilePayload) => {
      const { preview } = payload;
      state.uploadFrontDocument.preview = preview;
    },
    setUploadBackDocumentFile: (state, { payload }: UploadFilePayload) => {
      const { file } = payload;
      state.uploadBackDocument.file = file;
    },
    setUploadBackDocumentPreview: (state, { payload }: UploadFilePayload) => {
      const { preview } = payload;
      state.uploadBackDocument.preview = preview;
    },
    setUploadProfileFile: (state, { payload }: UploadFilePayload) => {
      const { file } = payload;
      state.uploadProfile.file = file;
    },
    setUploadProfilePreview: (state, { payload }: UploadFilePayload) => {
      const { preview } = payload;
      state.uploadProfile.preview = preview;
    },
    resetUploadProfile: (state) => {
      state.uploadProfile = initialState.uploadProfile;
    },
  },
});

export const profileActions = profileSlice.actions;
